var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppImageMeetingImageUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 16.656a2 2 0 01-2 2H3a2 2 0 01-2-2v-10a2 2 0 012-2h1.93a2 2 0 001.664-.89l1.11-1.664a1 1 0 01.831-.446h6.93a1 1 0 01.832.446l1.11 1.664a2 2 0 001.663.89H21a2 2 0 012 2v10z",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 14.656a3.5 3.5 0 100-7 3.5 3.5 0 000 7z",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppImageMeetingImageUpload);
export default __webpack_public_path__ + "static/media/app_image_meeting_image_upload.a1d176c59bd4986091928c2b3681c529.svg";
export { ForwardRef as ReactComponent };